class ProductReviews {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.addReviewCounts());
    } else {
      this.addReviewCounts();
    }
    this.observeForNewReviews();
  }

  addReviewCounts() {
    const reviewBadges = document.querySelectorAll('.jdgm-prev-badge');

    reviewBadges.forEach((badge) => {
      if (badge.dataset.reviewCountAdded) return;

      const numberOfReviews = badge.dataset.numberOfReviews || '0';
      const starsElement = badge.querySelector('.jdgm-prev-badge__stars');

      if (starsElement && !badge.querySelector('.review-count')) {
        const reviewCountElement = document.createElement('span');
        reviewCountElement.className = 'review-count';
        reviewCountElement.textContent = `(${numberOfReviews})`;

        starsElement.insertAdjacentElement('afterend', reviewCountElement);

        badge.dataset.reviewCountAdded = 'true';
      }
    });
  }

  observeForNewReviews() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('jdgm-prev-badge') || node.querySelector?.('.jdgm-prev-badge')) {
              shouldUpdate = true;
            }
          }
        });
      });

      if (shouldUpdate) {
        this.addReviewCounts();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

new ProductReviews();
